import SVG from "react-inlinesvg";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));

const MatchSummary = ({ matchData = null,scrolled = false, isTest=false }) => {
  const [activeCommTab, setActiveCommTab] = useState(1);
  const [innTab, setInnTab] = useState(1);
  const [batsmen, setBatsmen] = useState([]);
  const [bowlers, setBowlers] = useState([]);
  const [overDetails, setOverDetails] = useState([]);
  const [commentary, setCommentary] = useState([]);

  const commTabs = [
    { tabNo: 1, tabName: "All" },
    { tabNo: 2, tabName: "W" },
    { tabNo: 3, tabName: "4s" },
    { tabNo: 4, tabName: "6s" },
  ];

  useEffect(() => {
    if (!matchData) return;

    const inning = matchData?.currentInning=="First" ? 1 : matchData?.currentInning=="Second"? 2 : matchData?.currentInning=="Third" ? 3 : 4;

    setInnTab(inning);

    // Batsmen
    let batsmenData = (matchData?.currentInning === "First"
      ? matchData?.inn1_batsmen
      : matchData?.currentInning === "Second" ? matchData?.inn2_batsmen : matchData?.currentInning === "Third" ? matchData?.inn3_batsmen : matchData?.inn4_batsmen
    )?.filter(
      (batter) => batter.howOut === "not out" || batter.howOut === "Batting"
    );

    if (!batsmenData || batsmenData.length === 0) {
      batsmenData = matchData?.currentInning === "First"
        ? matchData?.inn1_batsmen?.slice(-2)
        : matchData?.currentInning === "Second" ? matchData?.inn2_batsmen?.slice(-2) : matchData?.currentInning === "Third" ? matchData?.inn3_batsmen?.slice(-2) : matchData?.inn4_batsmen?.slice(-2);
    }

    // Bowlers
    let bowlerData = (matchData?.currentInning === "First"
      ? matchData?.inn1_bowlers
      : matchData?.currentInning === "Second" ? matchData?.inn2_bowlers : matchData?.currentInning === "Third" ? matchData?.inn3_bowlers : matchData?.inn4_bowlers
    )?.filter((bowler) => bowler.bowlers === "Yes");

    if (!bowlerData || bowlerData.length === 0) {
      bowlerData = matchData?.currentInning === "First"
        ? matchData?.inn1_bowlers?.slice(-2)
        : matchData?.currentInning === "Second" ? matchData?.inn2_bowlers?.slice(-2) : matchData?.currentInning === "Third" ? matchData?.inn3_bowlers?.slice(-2) : matchData?.inn4_bowlers?.slice(-2);
    }

    // Commentary and Overs
    setBatsmen(batsmenData || []);
    setBowlers(bowlerData || []);
    setOverDetails(matchData?.over_details || []);
    setCommentary(matchData?.commentary || []);
  }, [matchData]);



  useEffect(() => {
    const filters = {
      1: matchData?.commentary, // All
      2: matchData?.commentary?.filter((item) => item.runs === "W"),
      3: matchData?.commentary?.filter((item) => item.runs === 4),
      4: matchData?.commentary?.filter((item) => item.runs === 6),
    };
    setCommentary(filters[activeCommTab] || matchData?.overDetails);
  }, [activeCommTab]);

  return matchData ? (
    <div className="w-full">
      {/* over runs data */}
      <div
        className="w-full overflow-x-auto flex items-center gap-2 mb-3"
        style={{ scrollbarWidth: "none" }}
      >
        {overDetails?.map((over, index) => {
          return (
            <div key={index} className="min-w-fit flex items-center gap-2">
              <div className="w-20 md:w-18 text-gray-500">
                {overDetails[index]?.overStats[0].over}
              </div>
              {over?.overStats?.map((item, index) => {
                return (
                  <div key={index} className="flex items-center gap-1">
                    <span
                      className={`w-8 h-8 p-1 text-center border border-gray-300 rounded-full overflow-hidden ${
                        item.runs == "6" || item.runs == "4"
                          ? "bg-blue-500 border-blue-500 text-white"
                          : ""
                      } ${
                        item.runs == "W"
                          ? "bg-red-500 border-red-500 text-white"
                          : ""
                      } ${item.runs.includes("WD")?"text-xs":""}`}
                    >
                      {item.runs}
                    </span>
                  </div>
                );
              })}
              <span className="w-10">{" = " + over.overTotal}</span>
              <span className="h-8 mx-2 border-l border-black"></span>
            </div>
          );
        })}
      </div>

      {/* man of the match  */}
      {matchData?.manOfMatch && (
        <div className="relative w-full rounded-lg mt-8 mb-1 bg-red-500 py-2 px-4 flex items-center justify-between">
          {matchData?.manOfMatch && (
            <div className="flex items-center gap-1 z-10">
              <img
                src={`https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/${matchData?.manOfMatchId}.png?size=100:100`}
                width={50}
                height={50}
                loading="lazy"
                onError={(e) => {
                  e.target.src =
                    "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
                }}
                alt="man of the match"
                className="rounded-full"
              />
              <div className="text-white font-semibold text-md md:text-lg">
                {matchData?.manOfMatch}
              </div>
            </div>
          )}

          <div className="flex items-start justify-end gap-1 pl-6 md:pl-0 max-w-[40%] md:max-w-[20%] z-10">
            <SVG src="/assets/icons/svg/bat.svg" className="mt-1" />
            <span className="pb-1 text-white italic font-semibold text-sm md:text-lg">
              MAN OF THE MATCH
            </span>
          </div>
        </div>
      )}

      {/* batsmen */}
      {batsmen?.length > 0 && (
        <div className="w-full border border-gray-300 rounded-lg my-4">
          <div className="px-4 py-2 w-full flex items-center gap-2 border-b border-gray-300">
            <div className="w-[50%] md:w-[60%] text-gray-500">Batters</div>
            <div className="w-[60%] md:w-[40%] text-gray-500 flex items-center gap-4 justify-end">
              <div className="w-[10%]">R</div>
              <div className="w-[10%]">B</div>
              <div className="w-[10%]">4s</div>
              <div className="w-[10%]">6s</div>
              <div className="w-[25%] md:w-[20%] text-center">SR</div>
            </div>
          </div>
          {batsmen.map((batsman, index) => {
            return (
              <div
                key={index}
                className={`px-4 py-2 w-full ${
                  index == 0 ? "border-b border-gray-300" : ""
                } flex items-center gap-2 text-sm md:text-md`}
              >
                <div className="w-[50%] md:w-[60%] flex flex-col gap-2">
                  <span className="flex items-center gap-1 line-clamp-1">
                    <span>{batsman?.batsmanName}</span>
                    {batsman?.striker == "Yes" && (
                      <SVG src="/assets/icons/svg/bat.svg" />
                    )}
                  </span>
                  <span className="text-gray-500 text-xs">Not out</span>
                </div>
                <div className="w-[60%] md:w-[40%] flex items-center gap-4 justify-end">
                  <div className="w-[10%]">{batsman?.runs || 0}</div>
                  <div className="w-[10%]">{batsman?.ballsFaced || 0}</div>
                  <div className="w-[10%]">{batsman?.fours || 0}</div>
                  <div className="w-[10%]">{batsman?.sixes || 0}</div>
                  <div className="w-[25%] md:w-[20%]">{batsman?.sr || 0}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {/* bowlers  */}
      {bowlers?.length > 0 && (
        <div className="w-full my-4 flex flex-col rounded-lg border border-gray-300">
          <div className="px-4 py-2 w-full flex items-center gap-2 border-b">
            <h2 className="w-[50%] md:w-[60%] text-gray-500">
              Bowlers
            </h2>
            <div className="w-[60%] md:w-[40%] text-gray-500 flex items-center gap-4 justify-end">
              <div className="w-[10%]">O</div>
              <div className="w-[10%]">M</div>
              <div className="w-[10%]">R</div>
              <div className="w-[10%]">W</div>
              <div className="w-[30%] md:w-[20%]">Econ</div>
            </div>
          </div>
          {bowlers?.map((bowler, index) => {
            return (
              <div
                key={index}
                className={`px-4 py-4 w-full ${
                  index != bowler.length - 2 ? "border-b border-gray-300" : ""
                } flex items-center gap-2 text-sm md:text-md`}
              >
                <div className="w-[50%] md:w-[60%]">
                  <span className="flex items-center gap-1">
                    {bowler?.bowlerName}
                    {bowler?.bowling =="Yes" && <SVG src="/assets/icons/svg/bowl.svg" />}
                  </span>
                </div>
                <div className="w-[60%] md:w-[40%] flex items-center gap-4 justify-end text-md text-gray-600">
                  <div className="w-[10%]">{bowler?.overs || 0}</div>
                  <div className="w-[10%]">{bowler?.maidens || 0}</div>
                  <div className="w-[10%]">{bowler?.runsGiven || 0}</div>
                  <div className="w-[10%]">{bowler?.wickets || 0}</div>
                  <div className="w-[30%] md:w-[20%]">{bowler?.econ || 0}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div className="w-full py-2 px-4 border border-gray-300 rounded-lg text-md text-gray-500">
        <span>Current Run Rate: </span>
        {matchData?.crr || 0.0}
      </div>
     {scrolled&& <div className="my-3">
        <AdSlot300x250
          divId={"div-gpt-ad-1659434785315-0"}
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId={"div-gpt-ad-1707804176041-3"}
          minWidth="720px"
          minHeight="90px"
        />
      </div>}
      {(matchData?.inn1_notes || matchData?.inn2_notes && !isTest) ? (
        <section className="w-full my-4 py-2">
          {/* notes  */}
          <h2 className="font-semibold text-lg">Top Moments</h2>

          <div className="flex items-center gap-2 my-2">
            {matchData?.inn1_team && (
              <button
                onClick={() => {
                  setInnTab(1);
                }}
                className={`border py-2 px-4 rounded-lg ${
                  innTab == 1 ? "bg-primary text-white" : ""
                }`}
              >
                First Innings
              </button>
            )}
            {matchData?.inn2_team && (
              <button
                onClick={() => {
                  setInnTab(2);
                }}
                className={`border py-2 px-4 rounded-lg ${
                  innTab == 2 ? "bg-primary text-white" : ""
                }`}
              >
                Second Innings
              </button>
            )}
            {matchData?.inn3_team && (
              <button
                onClick={() => {
                  setInnTab(3);
                }}
                className={`border py-2 px-4 rounded-lg ${
                  innTab == 3 ? "bg-primary text-white" : ""
                }`}
              >
                Third Innings
              </button>
            )}
            {matchData?.inn4_team && (
              <button
                onClick={() => {
                  setInnTab(4);
                }}
                className={`border py-2 px-4 rounded-lg ${
                  innTab == 4 ? "bg-primary text-white" : ""
                }`}
              >
                Fourth Innings
              </button>
            )}
          </div>
          {innTab == 1 &&
            matchData?.inn1_notes &&
            matchData?.inn1_notes.map((item, index) => {
              return (
                <div
                  key={index}
                  className="flex my-2 items-start gap-2 w-full rounded-lg p-4 border border-gray-300"
                >
                 <span className="rounded-full w-2 h-2 bg-primary"></span>
                 <span className="w-[95%] -mt-2">{item}</span>
                </div>
              );
            })}
          {innTab == 2 &&
            matchData?.inn2_notes &&
            matchData?.inn2_notes.map((item, index) => {
              return (
                <div
                  key={index}
                  className="flex my-2 items-start gap-2 w-full rounded-lg p-4 border border-gray-300"
                >
                  <span className="rounded-full w-2 h-2 bg-primary"></span>
                  <span className="w-[95%] -mt-2">{item}</span>
                </div>
              );
            })}
            {innTab == 3 &&
            matchData?.inn3_notes &&
            matchData?.inn3_notes.map((item, index) => {
              return (
                <div
                  key={index}
                  className="flex my-2 items-start gap-2 w-full rounded-lg p-4 border border-gray-300"
                >
                  <span className="rounded-full w-2 h-2 bg-primary"></span>
                  <span className="w-[95%] -mt-2">{item}</span>
                </div>
              );
            })}
            {innTab == 4 &&
            matchData?.inn4_notes &&
            matchData?.inn4_notes.map((item, index) => {
              return (
                <div
                  key={index}
                  className="flex my-2 items-start gap-2 w-full rounded-lg p-4 border border-gray-300"
                >
                  <span className="rounded-full w-2 h-2 bg-primary"></span>
                  <span className="w-[95%] -mt-2">{item}</span>
                </div>
              );
            })}
        </section>
      ) : commentary?.length ? (
        <section className="w-full my-4 py-2">
          {/* commentary  */}
          <h2 className="font-semibold text-lg">Commentary</h2>
          <div className="flex items-center gap-2 my-4">
            {commTabs.map((tab, index) => {
              return (
                <button
                  key={index}
                  onClick={() => {
                    setActiveCommTab(tab.tabNo);
                  }}
                  className={`px-3 py-2 text-center border border-gray-300 rounded-lg ${
                    activeCommTab == tab.tabNo
                      ? "border-primary text-white bg-primary"
                      : ""
                  }`}
                >
                  {tab.tabName}
                </button>
              );
            })}
          </div>
          {commentary?.map((comment, index) => {
            return (
              <div
                key={index}
                className="w-full px-2 py-1 border border-gray-300 rounded-lg my-4"
              >
                <div className="flex items-start gap-2">
                  <div className="w-[10%] flex flex-col md:flex-row items-center gap-2">
                    <div className="font-semibold">{comment?.currBall}</div>
                    <div
                      className={`w-8 p-1 rounded-full text-center text-sm border border-gray-300 ${
                        comment?.runs == "4" || comment?.runs == "6"
                          ? "border-blue-500 bg-blue-500 text-white"
                          : ""
                      } ${
                        comment?.runs == "W"
                          ? "border-red-500 bg-red-500 text-white"
                          : ""
                      }`}
                    >
                      {comment?.runs}
                    </div>
                  </div>

                  <div className="w-[90%] flex flex-col gap-2">
                    <span>{comment?.commSpeakers}</span>
                    <span className="text-gray-500">
                      {comment?.commHighlight}
                    </span>
                    <span className="text-gray-500">{comment?.comment}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </section>
      ) : (
        <div className="text-lg w-full text-center my-8 text-gray-500">
          मैच हाइलाइट्स के लिए बने रहें
        </div>
      )}
    </div>
  ) : (
    <div className="w-full flex flex-col items-center justify-center text-lg text-gray-500 mt-10 mb-12">
      <SVG src="/assets/icons/svg/NoMatchData.svg" className="w-22 h-122 rounded-full mb-4"/>
      मैच जल्दी शुरू होगा लाइव अपडेट्स के लिए बने रहें
    </div>
  );
};

export default MatchSummary;
